import React, { useEffect } from "react";
import _ from "lodash";
import { useSelector } from "react-redux";
import styles from "./PortalWidget.module.scss"
import externals from "../../../utils/externals";
import {ReactComponent as NetAppIcon} from "ui-components-rollup/src/images/netapp-services/netapp-n.svg";

const style = window.document.createElement('style');
style.type = 'text/css';
window.document.head.appendChild(style);

const load = _.once(() =>{
    if(externals.portalFrontend) {
        window.PortalWidget = {
            headerHeight: '73px',
            service: 'ontap-cloud',
            primaryColor: '#2359a3'
        };
        var a=document.createElement("script");
        a.src=externals.portalWidget;
        document.head.appendChild(a);
        window.PortalWidget.script=a;
    }
});

const hide = () => {
    style.innerHTML = `#portal-widget-frame-container {
        display: none;
    }`;
};

const show = () => {
    style.innerHTML = ``;
} ;

export default React.memo(() => {
    const showWidget = useSelector(state => state.app.showWidget && state.auth.isAuthenticated && state.app.appState === "ready");
    const appState = useSelector(state => state.app.appState);

    useEffect(() => {
        if(appState === "ready" && process.env.REACT_APP_IS_SAAS !== "true" && process.env.REACT_APP_IS_DARK !== "true") {
            load();
        }
    }, [appState]);

    useEffect(() => {
        if(showWidget){
            show();
        } else {
            hide();
        }
    }, [showWidget]);

    if(showWidget) {
        if(process.env.REACT_APP_IS_DARK) {
            return <div className={styles['base']}>
                <NetAppIcon className={styles['icon']}/>
            </div>
        } else {
            return <div className={styles['base']}/>
        }
    } else {
        return "";
    }
});
